import emilioPic from "@/public/images/artists/emilio.jpg";
import { Artist } from "@/types/types";

export const emilio = {
  id: "139",
  name: "Emilio",
  image: emilioPic,
  description: `Emilio's voice is both gentle and energetic, creating an engaging and soothing presence. Its expressive range and precise control make it ideal for pop, soul, and dance, effortlessly shining in both heartfelt ballads and lively, rhythmic tracks.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Femilio-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Latin", "Pop", "Dance", "Jazz", "Indie", "Ballads"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "High",
      },
      specific: {
        low: 50,
        high: 69,
      },
      sweetSpot: 60,
    },
  },
} as const satisfies Artist;
